(function () {
  "use strict";

  if (window.__agAddonSheetV13) return;

  var root = document.querySelector("[data-ag-addon-sheet]");
  if (!root) return;
  window.__agAddonSheetV13 = true;
  if (root.parentNode !== document.body) document.body.appendChild(root);

  var panel = root.querySelector("[data-ag-addon-panel]");
  var summary = root.querySelector("[data-ag-addon-summary]");
  var count = root.querySelector("[data-ag-addon-count]");
  var live = root.querySelector("[data-ag-addon-live]");
  var cartLink = root.querySelector("[data-ag-addon-cart]");
  var cartLinkLabel = root.querySelector("[data-ag-addon-cart-label]");
  var handle = root.querySelector("[data-ag-addon-handle]");
  var items = Array.prototype.slice.call(root.querySelectorAll("[data-ag-addon-item]"));
  var lastTrigger = null;
  var handledLineItems = typeof WeakSet === "function" ? new WeakSet() : null;
  var lastHandledLineItem = null;
  var openGeneration = 0;
  var stickyTrigger = null;
  var stickyForwardUntil = 0;
  var returnFocus = null;
  var lockedScrollY = 0;
  var inerted = [];
  var isOpen = false;
  var isClosing = false;
  var subscribed = false;
  var suppressDrawerUntil = 0;
  var pendingAdds = 0;
  var pendingItems = typeof WeakSet === "function" ? new WeakSet() : [];
  var addQueue = Promise.resolve();

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }

  function announce(message) {
    if (!live) return;
    live.textContent = "";
    window.setTimeout(function () { live.textContent = message; }, 20);
  }

  function itemCountText(n) {
    return n + " " + (n === 1 ? "item" : "items");
  }

  function setCartCount(n) {
    n = Number(n);
    if (!Number.isFinite(n) || n < 0) return;
    if (count) count.textContent = "· " + itemCountText(n);
  }

  function itemIds(item) {
    return [Number(item.getAttribute("data-variant-id")), Number(item.getAttribute("data-twin-id") || 0)].filter(Boolean);
  }

  function itemIsPending(item) {
    return Array.isArray(pendingItems) ? pendingItems.indexOf(item) !== -1 : pendingItems.has(item);
  }

  function setItemPending(item, pending) {
    if (!Array.isArray(pendingItems)) {
      if (pending) pendingItems.add(item);
      else pendingItems.delete(item);
      return;
    }
    var index = pendingItems.indexOf(item);
    if (pending && index === -1) pendingItems.push(item);
    if (!pending && index !== -1) pendingItems.splice(index, 1);
  }

  function markItem(item, added) {
    var button = item.querySelector("[data-ag-addon-add]");
    if (!button) return;
    if (itemIsPending(item) && !added) return;
    button.disabled = !!added;
    button.classList.toggle("is-added", !!added);
    button.textContent = added ? "Added" : "Add";
    button.setAttribute("aria-disabled", added ? "true" : "false");
  }

  function applyCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return items.length;
    var present = {};
    cart.items.forEach(function (line) {
      present[Number(line.variant_id || line.id)] = true;
    });
    var remaining = 0;
    items.forEach(function (item) {
      var added = itemIds(item).some(function (id) { return !!present[id]; });
      markItem(item, added);
      if (!added) remaining += 1;
    });
    setCartCount(cart.item_count);
    return remaining;
  }

  function getCart() {
    return fetch("/cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    }).then(function (response) {
      if (!response.ok) throw new Error("cart.js " + response.status);
      return response.json();
    });
  }

  function focusables() {
    if (!panel) return [];
    return Array.prototype.slice.call(panel.querySelectorAll("a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex='-1'])")).filter(function (element) {
      var style = window.getComputedStyle(element);
      return style.display !== "none" && style.visibility !== "hidden" && element.getClientRects().length > 0;
    });
  }

  function lockPage() {
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.setProperty("--ag-addon-scroll-offset", -lockedScrollY + "px");
    document.documentElement.classList.add("ag-addon-modal-open");
    document.body.classList.add("ag-addon-modal-open");
    inerted = [];
    Array.prototype.slice.call(document.body.children).forEach(function (element) {
      if (element === root || element.hasAttribute("inert")) return;
      element.setAttribute("inert", "");
      inerted.push(element);
    });
  }

  function unlockPage() {
    inerted.forEach(function (element) {
      if (element && element.isConnected) element.removeAttribute("inert");
    });
    inerted = [];
    document.documentElement.classList.remove("ag-addon-modal-open");
    document.body.classList.remove("ag-addon-modal-open");
    document.body.style.removeProperty("--ag-addon-scroll-offset");
    window.scrollTo(0, lockedScrollY);
  }

  function restoreTriggerFocus() {
    var target = returnFocus;
    returnFocus = null;
    if (!target || !target.isConnected || target.disabled) return;
    try { target.focus({ preventScroll: true }); } catch (_) { try { target.focus(); } catch (_error) {} }
    if (document.activeElement !== target) {
      var fallback = document.querySelector('form[action*="/cart/add"] button[name="add"]');
      if (fallback && !fallback.disabled) {
        try { fallback.focus({ preventScroll: true }); } catch (_) { try { fallback.focus(); } catch (_error) {} }
      }
    }
  }

  function finishClose() {
    root.hidden = true;
    root.setAttribute("aria-hidden", "true");
    isClosing = false;
    unlockPage();
    restoreTriggerFocus();
  }

  function closeSheet() {
    if (!isOpen || isClosing) return;
    isOpen = false;
    isClosing = true;
    root.classList.remove("is-open");
    window.setTimeout(finishClose, reducedMotion() ? 0 : 270);
  }

  function openSheet(lineItem, cart, trigger) {
    if (isOpen || isClosing) return;
    isOpen = true;
    returnFocus = trigger && trigger.isConnected ? trigger : (lastTrigger && lastTrigger.isConnected ? lastTrigger : document.activeElement);
    suppressDrawerUntil = Date.now() + 6000;

    var title = lineItem && (lineItem.product_title || lineItem.title);
    if (summary) summary.textContent = "Added to your cart";
    applyCart(cart);
    root.hidden = false;
    root.setAttribute("aria-hidden", "false");
    lockPage();
    closeThemeDrawer();
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { root.classList.add("is-open"); });
    });
    window.setTimeout(function () {
      if (!isOpen || !panel) return;
      try { panel.focus({ preventScroll: true }); } catch (_) { panel.focus(); }
      announce(title ? "Added " + title + " to your cart" : "Item added to your cart");
    }, reducedMotion() ? 0 : 70);
  }

  function prepareAndOpen(lineItem) {
    if (lineItem && typeof lineItem === "object") {
      if (handledLineItems && handledLineItems.has(lineItem)) return;
      if (!handledLineItems && lineItem === lastHandledLineItem) return;

      if (handledLineItems) handledLineItems.add(lineItem);
      lastHandledLineItem = lineItem;
    }

    var generation = ++openGeneration;
    var trigger = lastTrigger;
    getCart().then(function (cart) {
      if (generation !== openGeneration || isOpen || isClosing) return;
      if (applyCart(cart) < 1) return;
      openSheet(lineItem, cart, trigger);
    }).catch(function () {
      if (generation !== openGeneration || isOpen || isClosing) return;
      openSheet(lineItem, null, trigger);
    });
  }

  function closeThemeDrawer() {
    if (!isOpen || Date.now() > suppressDrawerUntil) return;
    var cart = window.MinimogTheme && window.MinimogTheme.Cart;
    if (cart && typeof cart.closeCartDrawer === "function") {
      window.setTimeout(function () {
        if (isOpen) cart.closeCartDrawer();
      }, 0);
    }
  }

  function getThemeCartDrawer() {
    var cart = window.MinimogTheme && window.MinimogTheme.Cart;
    var drawer = document.querySelector(".scd__wrapper");
    if (!cart || typeof cart.openCartDrawer !== "function" || !drawer) return null;
    if (cart.isCartPage || cart.enableCartDrawer === false) return null;
    return cart;
  }

  function openThemeCartDrawer(href) {
    var cart = getThemeCartDrawer();
    if (!cart) return false;
    closeSheet();
    window.setTimeout(function () {
      Promise.resolve().then(function () {
        if (typeof cart.renderNewCart === "function") return cart.renderNewCart();
      }).then(function () {
        var currentCart = getThemeCartDrawer();
        if (!currentCart) throw new Error("Cart drawer unavailable");
        currentCart.openCartDrawer();
        window.setTimeout(function () {
          var drawer = document.querySelector(".scd__wrapper");
          if (!drawer || drawer.classList.contains("hidden")) window.location.assign(href);
        }, 80);
      }).catch(function () {
        window.location.assign(href);
      });
    }, reducedMotion() ? 0 : 280);
    return true;
  }

  function onKeydown(event) {
    if (!isOpen) return;
    if (event.key === "Escape" || event.keyCode === 27) {
      event.preventDefault();
      closeSheet();
      return;
    }
    if (event.key !== "Tab" && event.keyCode !== 9) return;
    var controls = focusables();
    if (!controls.length) {
      event.preventDefault();
      panel.focus();
      return;
    }
    var first = controls[0];
    var last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function onFocusin(event) {
    if (isOpen && panel && !panel.contains(event.target)) {
      event.stopPropagation();
      panel.focus();
    }
  }

  function updateThemeCart(cart) {
    setCartCount(cart && cart.item_count);
    var themeUpdate = Promise.resolve();
    try {
      if (window.Shopify && typeof window.Shopify.onCartUpdate === "function") {
        themeUpdate = Promise.resolve(window.Shopify.onCartUpdate(cart, false));
      }
    } catch (_) {}

    return themeUpdate.then(function () {
      var themeCart = window.MinimogTheme && window.MinimogTheme.Cart;
      if (themeCart && typeof themeCart.renderNewCart === "function" && !themeCart.isCartPage) {
        return themeCart.renderNewCart();
      }
    }).then(function () {
      try {
        document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
        document.dispatchEvent(new CustomEvent("cart:refresh", { detail: cart }));
      } catch (_) {}
    });
  }

  function addOne(item, button) {
    var variantId = Number(item.getAttribute("data-variant-id"));
    if (!variantId) return Promise.resolve();
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (json) {
        if (!response.ok) throw new Error(json.description || "Unable to add this item");
        return json;
      });
    }).then(function () {
      markItem(item, true);
      announce("Add-on added to your cart");
      return getCart().then(function (cart) {
        applyCart(cart);
        return updateThemeCart(cart);
      }).catch(function () {
        /* The item is already in Shopify at this point. Never invite a retry
           that could double-add it just because a surface refresh failed. */
        announce("Add-on added. Open your cart to review it.");
      });
    }).catch(function () {
      button.disabled = false;
      button.classList.remove("is-added");
      button.setAttribute("aria-disabled", "false");
      button.textContent = "Try again";
      announce("That add-on could not be added. Please try again.");
    });
  }

  function queueAdd(button) {
    var item = button.closest("[data-ag-addon-item]");
    if (!item || button.disabled || itemIsPending(item)) return;
    setItemPending(item, true);
    button.disabled = true;
    button.textContent = "Adding…";
    pendingAdds += 1;
    addQueue = addQueue.catch(function () {}).then(function () {
      return addOne(item, button);
    }).then(function () {
      setItemPending(item, false);
      pendingAdds -= 1;
    }, function () {
      setItemPending(item, false);
      pendingAdds -= 1;
    });
  }

  function bindSwipe() {
    if (!handle || !panel) return;
    var startY = 0;
    var startTime = 0;
    var distance = 0;
    var dragging = false;
    var ignoreClick = false;

    handle.addEventListener("pointerdown", function (event) {
      if (!isOpen || (window.matchMedia && !window.matchMedia("(max-width: 749px)").matches)) return;
      dragging = true;
      startY = event.clientY;
      startTime = Date.now();
      distance = 0;
      ignoreClick = false;
      panel.style.transition = "none";
      try { handle.setPointerCapture(event.pointerId); } catch (_) {}
    });

    handle.addEventListener("pointermove", function (event) {
      if (!dragging || !isOpen) return;
      distance = Math.max(0, event.clientY - startY);
      panel.style.transform = "translateY(" + distance + "px)";
    });

    function finishSwipe() {
      if (!dragging) return;
      dragging = false;
      panel.style.transition = "";
      panel.style.transform = "";
      var elapsed = Math.max(1, Date.now() - startTime);
      ignoreClick = distance > 6;
      if (distance > 90 || (distance > 44 && distance / elapsed > 0.55)) closeSheet();
    }

    handle.addEventListener("pointerup", finishSwipe);
    handle.addEventListener("pointercancel", finishSwipe);
    handle.addEventListener("click", function () {
      if (ignoreClick) { ignoreClick = false; return; }
      if (isOpen && !dragging) closeSheet();
    });
  }

  document.addEventListener("pointerdown", function (event) {
    var trigger = event.target.closest && event.target.closest("[data-agpe-atc], button.add-to-cart");
    if (!trigger) return;
    lastTrigger = trigger;
    if (trigger.matches("[data-agpe-atc]")) {
      stickyTrigger = trigger;
      stickyForwardUntil = Date.now() + 1200;
    }
  }, true);

  document.addEventListener("click", function (event) {
    var dismiss = event.target.closest && event.target.closest("[data-ag-addon-dismiss]");
    if (dismiss && root.contains(dismiss)) {
      event.preventDefault();
      closeSheet();
      return;
    }
    var add = event.target.closest && event.target.closest("[data-ag-addon-add]");
    if (add && root.contains(add)) {
      event.preventDefault();
      queueAdd(add);
      return;
    }
    var trigger = event.target.closest && event.target.closest("[data-agpe-atc], button.add-to-cart");
    if (!trigger) return;
    if (trigger.matches("[data-agpe-atc]")) {
      stickyTrigger = trigger;
      stickyForwardUntil = Date.now() + 1200;
    }
    if (!event.isTrusted && stickyTrigger && Date.now() < stickyForwardUntil && trigger.matches("button.add-to-cart")) {
      lastTrigger = stickyTrigger;
    } else {
      lastTrigger = trigger;
    }
  }, true);

  if (cartLink) {
    cartLink.addEventListener("click", function (event) {
      var href = cartLink.href;
      var drawerAvailable = !!getThemeCartDrawer();
      if (!pendingAdds && !drawerAvailable) return;
      event.preventDefault();
      if (pendingAdds) {
        cartLink.setAttribute("aria-busy", "true");
        if (cartLinkLabel) cartLinkLabel.textContent = "Finishing your cart…";
      }
      addQueue.then(function () {
        cartLink.removeAttribute("aria-busy");
        if (cartLinkLabel) cartLinkLabel.textContent = "View cart";
        if (!openThemeCartDrawer(href)) window.location.assign(href);
      });
    });
  }

  document.addEventListener("keydown", onKeydown, true);
  document.addEventListener("focusin", onFocusin, true);
  bindSwipe();

  function subscribeToTheme() {
    if (subscribed || !window.MinimogEvents || typeof window.MinimogEvents.subscribe !== "function") return false;
    subscribed = true;
    window.MinimogEvents.subscribe("ON_ITEM_ADDED", prepareAndOpen);
    window.MinimogEvents.subscribe("ON_OPEN_DRAWER_CART", closeThemeDrawer);
    window.MinimogEvents.subscribe("ON_CART_UPDATE", function (cart) {
      if (isOpen) applyCart(cart);
    });
    return true;
  }

  if (!subscribeToTheme()) {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (subscribeToTheme() || attempts >= 150) window.clearInterval(timer);
    }, 100);
  }
})();
